import { Button, ButtonGroup, Card, Modal, StatusIconProtoProps } from '@nike/eds';
import { VisitorPass } from '../../../models/IVisitorPass';
import { Dispatch, FC, SetStateAction } from 'react';
import { translations as ts } from './i18n';
import { useI18nContext } from '../../../context/language/use-i18n-context';
import { CancelPass } from '../../../services/pass-service';

export interface Props {
  pass: VisitorPass | undefined;
  onDismiss: () => void;
  isVisible: boolean;
  setSnackbar: Dispatch<
    SetStateAction<{
      showSnack: boolean;
      message: string;
      snackStatus: StatusIconProtoProps['status'];
    }>
  >;
}
export const CancelPassModal: FC<Props> = ({ pass, onDismiss, isVisible, setSnackbar }) => {
  const { i18nString } = useI18nContext();

  const cancelPass = (passId: number) => {
    CancelPass(passId)
      .then(() => {
        onDismiss();
        setSnackbar({
          message: i18nString(ts.TOASTR_PASS_CANCELED),
          showSnack: true,
          snackStatus: 'success',
        });
      })
      .catch(() => {
        setSnackbar({
          message: 'Error cancelling the pass',
          showSnack: true,
          snackStatus: 'error',
        });
      });
  };
  const footer = (
    <>
      <ButtonGroup className={`eds-flex eds-flex--justify-content-center`}>
        <Button
          size="small"
          variant="primary"
          onClick={onDismiss}
          data-testid="keep-pass"
          className="txt_uppercase"
        >
          {i18nString(ts.CANCEL_PASS_MODAL_KEEP_PASS)}
        </Button>
        <Button
          size="small"
          variant="primary"
          onClick={() => cancelPass(pass?.passId || 0)}
          data-testid="cancel-pass-btn"
          className="txt_uppercase"
        >
          {i18nString(ts.CANCEL_PASS_MODAL_CANCEL_PASS)}
        </Button>
      </ButtonGroup>
    </>
  );
  const header = (
    <>
      <div
        data-testid="cancel-pass-header"
        className={`eds-flex eds-flex--justify-content-center  modal_header`}
      >
        {i18nString(ts.CANCEL_PASS_MODAL_TITLE)}
      </div>
    </>
  );
  return (
    <>
      <Modal
        hideFade
        isOpen={isVisible}
        headerSlot={header}
        onDismiss={onDismiss}
        footerSlot={footer}
        id="cancel-pass"
        data-testid="cancel-pass-modal"
      >
        <Card>
          <div
            className={`txt_uppercase txt_fontbold eds-type-display-5 eds-flex eds-flex--justify-content-center`}
          >
            {' '}
            {i18nString(ts.CANCEL_PASS_MODAL_NOTIFY)}
          </div>
          <div
            className={`txt_uppercase txt_fontbold txt_color eds-flex eds-flex--justify-content-center`}
          >
            {' '}
            {pass?.firstName} {pass?.lastName}
          </div>
        </Card>
      </Modal>
    </>
  );
};
